import {AiChatDialog} from '@features/ai-chatbot/components/ai-chatbot-dialog'
import {AiChatPopover} from '@features/ai-chatbot/components/ai-chatbot-popover'

/**
 * Floating AI assistant. The panel is a popover on desktop and a fullscreen
 * dialog on mobile; only one of the two renders at a time.
 */
export const AiChat = () => {
    return (
        <>
            <AiChatPopover />
            <AiChatDialog />
        </>
    )
}

AiChat.displayName = 'AiChat'
